import createAction, {ReducerActionInterface} from "../../../lib/reducer.utils";
import {ContactModel} from "../../../models/contact.model";

/* Action types */
export const ActionTypes = {
    SET_VALUE: "SET_VALUE",
    CLEAR_CONTENT: "CLEAR_CONTENT",
    INIT_EVENT: "INIT_EVENT"
}

const INITIAL_STATE: ContactModel = {
    email: "", id: 0, message: "", name: ""
}

export const contactReducer = (state = INITIAL_STATE, action: ReducerActionInterface) => {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.INIT_EVENT:
            return payload;

        case ActionTypes.CLEAR_CONTENT: return INITIAL_STATE;
        case ActionTypes.SET_VALUE:
            return {
                ...state,
                [payload.key]: payload.value
            }

        default: return state;
    }
}

/* Selectors */
export const getContactData = (state: any) => state.event;

/* Actions */
export const initContact = (payload: ContactModel) => createAction({
    type: ActionTypes.INIT_EVENT,
    payload: payload
})

export const clearContactContent = () => createAction({
    type: ActionTypes.CLEAR_CONTENT
})

export const setContactValue = (key: any, value: any) => createAction({
    type: ActionTypes.SET_VALUE,
    payload: {
        key,
        value
    }
})